import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-border py-12 bg-white">
      <div className="content-width flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <p className="font-heading text-base font-bold text-foreground">
            One Click Essentials
          </p>
          <p className="text-sm text-muted-foreground mt-1">
            Simplifying grocery procurement for households.
          </p>
        </div>
        <div className="flex items-center gap-6 text-sm text-muted-foreground">
          <a href="mailto:hello@oneclickessentials.com" className="hover:text-primary transition-colors">
            Contact
          </a>
          <a href="#" className="hover:text-primary transition-colors">
            Instagram
          </a>
          <a href="#" className="hover:text-primary transition-colors">
            Twitter
          </a>
        </div>
      </div>
      <div className="content-width mt-8">
        <p className="text-xs text-muted-foreground">
          &copy; 2026 One Click Essentials. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
